
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"none"}},[_c('path',{attrs:{"d":"M2 5.5a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3v-14zm3-1a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1v-14a1 1 0 00-1-1H5z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M17.316 6.551a1 1 0 01.633 1.265l-2 6a1 1 0 01-1.145.665l-4.31-.862-2.637 4.396a1 1 0 01-1.714-1.03l3-5a1 1 0 011.053-.466l4.135.827 1.72-5.162a1 1 0 011.265-.633z","clip-rule":"evenodd"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      